import React from "react"
import PropTypes from "prop-types"
import {
  formatCurrency,
  formatPercentage,
  formatNumber,
} from "../../helpers/functions"

export default class FormNumericInput extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    format: PropTypes.oneOf(["number", "percentage", "currency"]),
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }

  static defaultProps = {
    type: "number",
    minValue: 0,
    maxValue: Infinity,
  }

  static getDerivedStateFromProps(props, state) {
    return {
      focused: state ? state.focused : false,
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      focused: false,
    }
  }

  _parse = textValue => parseFloat(textValue).toFixed(4)

  _onBlur = event => {
    this.setState({ ...this.state, focused: false })
  }

  _onFocus = event => {
    this.setState({ ...this.state, focused: true })
  }

  _onChange = event => {
    event.preventDefault()
    const { format, onChange, minValue, maxValue } = this.props
    const newEvent = { ...event, preventDefault: () => {} }
    const { value: textValue } = event.target
    let value =
      textValue.length <= 0
        ? 0
        : Math.min(maxValue, Math.max(minValue, this._parse(textValue)))
    if (format === "percentage") {
      value /= 100
    }
    newEvent.target.value = `${value}`
    onChange(newEvent)
  }

  _formatValueForDisplay = textValue => {
    const { format } = this.props
    const value = this._parse(textValue)
    if (format === "currency") {
      return formatCurrency(value)
    } else if (format === "percentage") {
      return formatPercentage(value)
    }
    return formatNumber(value)
  }

  _formatValueForEditing = textValue => {
    const { format } = this.props
    let value = this._parse(textValue)
    if (format === "percentage") {
      value *= 100
    }
    return formatNumber(value, {
      minimumFractionDigits: format === "percentage" ? 2 : 0,
      maximumFractionDigits: 2,
      useGrouping: false,
    })
  }

  render() {
    const { label: title, name, value: rawValue } = this.props
    const { focused } = this.state
    const value = `${rawValue}`
    return (
      <label>
        {title && <span>{title}</span>}
        <input
          name={name}
          value={
            focused
              ? this._formatValueForEditing(value)
              : this._formatValueForDisplay(value)
          }
          onBlur={this._onBlur}
          onFocus={this._onFocus}
          onChange={this._onChange}
        />
      </label>
    )
  }
}
